import { render, staticRenderFns } from "./TheMarkdown.vue?vue&type=template&id=c7127516&scoped=true"
import script from "./TheMarkdown.vue?vue&type=script&lang=js"
export * from "./TheMarkdown.vue?vue&type=script&lang=js"
import style0 from "./TheMarkdown.vue?vue&type=style&index=0&id=c7127516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7127516",
  null
  
)

export default component.exports